
// const openModalBtn = document.getElementById('openModalBtn');
// const modalOverlay = document.getElementById('modalOverlay');
// const modalhide = document.querySelector('.modalHide');

//     function updateWindowWidth() {
//       const width = window.innerWidth; 
//     }

//     updateWindowWidth();

//     window.addEventListener('resize', updateWindowWidth);


//   if (width > 1076){
//     document.addEventListener('click', function(e) {
//       if (!modalhide.contains(e.target) && !openModalBtn.contains(e.target)) {
//         modalOverlay.classList.remove('show');
//       }
      
//       if (openModalBtn.contains(e.target)) {
//         modalOverlay.classList.toggle('show');
//       }
    
//       if (modalhide.contains(e.target)){
//         modalOverlay.classList.add('show')
//       }
//     });
//     }
    


const openModalBtn = document.getElementById('openModalBtn');
const modalOverlay = document.getElementById('modalOverlay');
const modalhide = document.querySelector('.modalHide');

function updateWindowWidth() {
    const width = window.innerWidth; 
    document.addEventListener('click', handleModalClick);
    // if (width > 1076) {
    //     document.addEventListener('click', handleModalClick);
    // } else {
    //     document.removeEventListener('click', handleModalClick);
    // }
}

function handleModalClick(e) {
    if (!modalhide.contains(e.target) && !openModalBtn.contains(e.target)) {
        modalOverlay.classList.remove('show'); 
    }

    if (openModalBtn.contains(e.target)) {
        modalOverlay.classList.toggle('show');
    }

    if (modalhide.contains(e.target)) {
        modalOverlay.classList.add('show'); 
    }
}

updateWindowWidth();

window.addEventListener('resize', updateWindowWidth);
